module.exports = __webpack_public_path__ + "static/media/food-img.ba797b25.png";